import { ConfirmationModalState } from '@models/ConfirmationModalState';
import { create } from 'zustand';
import { ReactNode } from 'react';

export const useConfirmationModalStore = create<ConfirmationModalState>(
  (set) => ({
    isOpen: false,
    touched: false,
    title: '',
    content: '',
    error: false,
    setOnOK: (fn) => set({ onOk: fn }),
    onOk: () => {},
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
    handleClose: () => set({ isOpen: false }),
    handleOpen: () => set({ isOpen: true }),
    setTitle: (title: string) => set({ title }),
    setContent: (content: string | ReactNode) => set({ content }),
    setTouch: (touched: boolean) => set({ touched }),
    setError: (error: boolean) => set({ error }),
  })
);
